import { render, staticRenderFns } from "./SelectableCategories.vue?vue&type=template&id=64aca506&"
import script from "./SelectableCategories.vue?vue&type=script&lang=ts&"
export * from "./SelectableCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports